import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class SalesUnitActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Unit/UnitBrowser")
	}

	render() {
		return (
			<Activity 
				name="SalesUnit"
				RenderedComponent={this.RenderedComponent}
				context="SalesUnit"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(SalesUnitActivity)
